import LiquidacionService from "../../../../modules/Liquidacion/application/LiquidacionService"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { useState, useEffect } from "react"
import { WEBURLEGALES } from "../../../helpers/frontend.js"
import { WindowOpener } from "../../../helpers/window-opener"
import { Spinner, Boton } from "asocomponents"
import BotonEstado from "../../atomos/BotonEstado/BotonEstado.jsx"
import { mostrarMensaje } from "../../../helpers/mensajeria"
import { MENSAJESAPP } from "../../../const/constantes.js";

function GrillaComprobantes() {

  //Recupero el Idusuario del session que vino del Loguin y lo uso como idprevencionista
  const usuarioString = JSON.parse(sessionStorage.getItem('usuario'))
  const idUsuarioLetrado = usuarioString && usuarioString.idusuario
  const cuitLetrado = usuarioString && usuarioString.usuario
  const [isLoading, setIsLoading] = useState(false)
  const [resultado, setResultado] = useState([])
  const [message, setMessage] = useState("")
  const [existenRdos, setExistenRdos] = useState(true)

  //PARA EL PAGINADO
  const [paginaActual, setPaginaActual] = useState(1)
  const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página

  //Recupero los filtros desde Redux que vienen desde FiltroVisitas.jsx
  const filtros = useSelector((state) => state.rootReducer.filtrosLiquidaciones)

  //#region paginado y fetchData
  const indiceUltimoElemento = paginaActual * elementosPorPagina
  const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
  let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

  const elementosPaginados =
    resultado === null
      ? []
      : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina)
  }

  const handleComprobanteTransf = () => {
    mostrarMensaje(MENSAJESAPP.ERRORES.COMPROBANTENODISPONIBLE, "info", 5000)
  }

  const fecthData = async () => {
    if (idUsuarioLetrado) {
      setIsLoading(true)
      const liquidacionService = new LiquidacionService()
      const result = await liquidacionService.getListLiquidaciones(cuitLetrado, filtros.nroSiniestro, filtros.caratula, filtros.expediente, filtros.idJuicio)

      if (result.length === 0) {
        setExistenRdos(false)
      }
      else
        setExistenRdos(true)
      setPaginaActual(1)
      setResultado(result)
      setIsLoading(false)
    }
  }

  const sonResponse = (err, res) => {
    if (err) {
      setMessage(res)
    } else {
      setMessage(res)
    }
  }

  useEffect(() => {
    if ((filtros.caratula && filtros.caratula !== "") || (filtros.nroSiniestro && filtros.nroSiniestro !== "") || (filtros.expediente && filtros.expediente !== "") || (filtros.idJuicio && filtros.idJuicio !== ""))
      fecthData()
  }, [filtros])

  if (isLoading) {
    return <Spinner color="red" size="50" />
  }

  return (
    <div className="overflow-x-auto">
      <div className="relative overflow-hidden shadow-md sm:rounded-lg m-3">
        <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-[99%] ">
          <thead className="text-[0.7rem] text-gray-700 uppercase bg-gray-200">
            <tr>
              <th scope="col" className="px-6 py-3 text-center" style={{ width: "12%" }}>
                Factura
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "8%" }}>
                F. Ent.
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "8%" }}>
                F. Vto.
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "10%" }}>
                Id Juicio
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "10%" }}>
                Nro Exp
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "20%" }}>
                Proc. Judicial
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "15%" }}>
                Razón Social
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "12%" }}>
                Importe
              </th>
              <th scope="col" className="px-6 py-3" style={{ width: "9%" }}>
                Estado
              </th>
              <th scope="col" className="text-center" style={{ width: "3%" }}></th>
              <th scope="col" className="text-center" style={{ width: "3%" }}></th>
            </tr>
          </thead>
          <tbody>
            {elementosPaginados &&
              elementosPaginados.map((liquidacion) => (
                <tr
                  className="bg-white border-b hover:bg-gray-50 text-[0.7rem]"
                  key={liquidacion.idLiquidacion}
                >
                  <td className="px-6 py-2">{liquidacion.nroFactura}</td>
                  <td className="px-6 py-2">{liquidacion.fechaEntrada}</td>
                  <td className="px-6 py-2">{liquidacion.fechaVencimiento}</td>
                  <td className="px-6 py-2">{liquidacion.idJuicio}</td>
                  <td className="px-6 py-2">{liquidacion.expediente}</td>
                  <td className="px-6 py-2">{liquidacion.procesoJudicial}</td>
                  <td className="px-6 py-2">{liquidacion.prestador}</td>
                  <td className="px-6 py-2">$ {liquidacion.importe}</td>
                  <td className="px-6 py-2"><BotonEstado estado={liquidacion.estado} /></td>
                  <td className="py-2">
                    {liquidacion?.nroFactura && liquidacion?.estado === 'Pagada' &&
                      <div className="flex flex-row">
                        <WindowOpener url={`${WEBURLEGALES}/VisorPDFCertificado/${liquidacion.idLiquidacion}/${liquidacion.nroFactura ? liquidacion.anioFiscal + liquidacion.nroGestion : liquidacion.nroRecibo}`} bridge={sonResponse} width={900} height={600} >
                          <Boton icono="retencion" height="h-6" alt="Certificado Retenciones" />
                        </WindowOpener>
                      </div>
                    }
                  </td>
                  <td className="py-2">
                    {liquidacion?.estado === 'Pagada' && (
                      (liquidacion?.cbuPiscysNumerico || (!liquidacion?.cbuPiscysNumerico && !liquidacion?.cbuPiscys)) ?
                        <div className="flex flex-row">
                          <WindowOpener url={`${WEBURLEGALES}/VisorPDFComprobanteTransferencia/${liquidacion.idLiquidacion}/${liquidacion.nroFactura}/${liquidacion.nroFactura ? liquidacion.anioFiscal + liquidacion.nroGestion : liquidacion.nroRecibo}`} bridge={sonResponse}>
                            <Boton icono="transferencia" height="h-6" alt="Comprobante Transferencia" />
                          </WindowOpener>
                        </div>
                        :
                        <div className="flex flex-row">
                          <Boton icono="transferencia" height="h-6" alt="Comprobante Transferencia" onClick={handleComprobanteTransf} />
                        </div>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {!existenRdos &&
        <div className="flex flex-row items-center justify-center h-full">
          <div className="font-semibold text-lg text-center mb-4">
            No encontramos ningún registro para tu búsqueda
          </div>
          <div className="w-[300px] flex justify-center ml-40">
            <img src={`${WEBURLEGALES}/images/papers.svg`} alt="Sin resultados" />
          </div>
        </div>
      }
      <div className="col-span-2 flex justify-end items-center m-2">
        <span className="text-sm m-1">
          Página {paginaActual} de {totalPaginas}
        </span>
        <button
          className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
          onClick={() => cambiarPagina(paginaActual - 1)}
          disabled={paginaActual === 1}
        >
          {"<"}
        </button>
        <button
          className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
          onClick={() => cambiarPagina(paginaActual + 1)}
          disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
        >
          {">"}
        </button>
      </div>
    </div>
  )
}

export default GrillaComprobantes
